export const GoogleKeys = {
  webClientId:
    '62646021413-queb1g13go0snvnotl0ee06t68jcgb98.apps.googleusercontent.com',
  androidClientId:
    '487300478427-t714e2673dt733n1t4gjop3grpl3bu6s.apps.googleusercontent.com',
};
